// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container__3G_yg","title":"NotFound_title__3G_Aa","description":"NotFound_description__3R-uS"};